export enum CategoryType {
  maybeInterestedIn = 'maybeInterestedIn'
}
